var map = {
	"./arrow_up.svg": 6423,
	"./arrows.svg": 3604,
	"./attestat.svg": 7890,
	"./az.svg": 5827,
	"./button.svg": 2486,
	"./ca.svg": 9986,
	"./call.svg": 8418,
	"./diplom.svg": 6427,
	"./en.svg": 8987,
	"./facebook.svg": 6338,
	"./flags.svg": 7175,
	"./hamburger.svg": 3631,
	"./instagram.svg": 1574,
	"./kursi.svg": 9707,
	"./linkedin.svg": 7464,
	"./logo.svg": 3935,
	"./logo_only.svg": 1656,
	"./ru.svg": 3709,
	"./search.svg": 8246,
	"./stipendiya.svg": 5538,
	"./symbol.svg": 2190,
	"./telegram.svg": 5039,
	"./template.svg": 8964,
	"./threads.svg": 7485,
	"./tiktok.svg": 2088,
	"./usa.svg": 3875,
	"./whatsapp.svg": 6144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;